import { ANONYMOUS_PASSWORD, ANONYMOUS_USER } from '@avanta/shared/constants/common';
import { oauthToken } from '@avanta/shared/services/auth';
import { TrackingService } from '@avanta/shared/services/tracking';
import {
  type CreateTracking,
  type TrackingData,
  type TrackingEventsType,
} from '@avanta/shared/types/tracking';
import { type UseTrackingByEmail } from './types';

export function useTrackingByEmail(): UseTrackingByEmail {
  const trackByEmail = async (
    email: string,
    event: TrackingEventsType,
    partialData: Partial<TrackingData> = {}
  ): Promise<void> => {
    const baseData: Partial<TrackingData> = {
      timestamp: new Date().toISOString(),
      email,
    };

    const payload: CreateTracking = {
      event,
      data: {
        ...baseData,
        ...partialData,
      },
    };

    try {
      const tokenResponse = await oauthToken(ANONYMOUS_USER, ANONYMOUS_PASSWORD);
      const token = tokenResponse?.data?.access_token;

      const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept-Language': 'es',
      };

      await TrackingService.createTrackingByEmail(email, payload, { headers });
    } catch (error) {
      throw new Error(`Failed to track by email: ${error}`);
    }
  };

  return { trackByEmail };
}
